import script from "./invoiceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./invoiceCard.vue?vue&type=script&setup=true&lang=ts"

import "./invoiceCard.vue?vue&type=style&index=0&id=674b1425&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674b1425"]])

export default __exports__